import { createTreatmentHook } from "./createTreatmentHook";

export const useSkinProtectant = createTreatmentHook(
  "skinprotectant",
  (s) => s.patient.skinProtectantListOptions,
  (s) => s.patient.skinProtectantGetData
);

export const useWoundCleanser = createTreatmentHook(
  "woundcleanser",
  (s) => s.patient.woundCleanserListOptions,
  (s) => s.patient.woundCleanserGetData
);

export const usePrimaryDressing = createTreatmentHook(
  "primarydressing",
  (s) => s.patient.primaryDressingListOptions,
  (s) => s.patient.primaryDressingGetData
);

export const useCompression = createTreatmentHook(
  "compression",
  (s) => s.patient.compressionListOptions,
  (s) => s.patient.compressionGetData
);